import { embeddedScriptAppStatus } from '../components/manage-installed-apps-page';
import { isEmbeddedScriptApp } from '../utils/appUtils';
import { filterBusinessSolutionApps, filterDismissedBundleApps } from '..';
import { getEligibleAppsForFreeTrial } from '@wix/ambassador-appmarket-v1-app-subscriptions/http';
import { getSection, } from '@wix/ambassador-appmarket-v1-section/http';
import { SectionsPlacement } from '@wix/ambassador-appmarket-v1-section/types';
export const fetchAppIdsByTag = (baseUrl, httpClient, local, tagId) => {
    if (httpClient) {
        return httpClient
            .post(`${baseUrl}/_api/tags-apps/v1/apps-by-tag`, { tagId }, {
            withCredentials: true,
        })
            .then((res) => res && res.data)
            .catch((error) => {
            console.log('cannot fetch app ids by tag', error);
            return Promise.resolve([]);
        });
    }
    return Promise.resolve([]);
};
export const fetchBundleApps = async (baseUrl, httpClient, local, geo) => {
    if (httpClient) {
        httpClient.request(getSection({ placement: SectionsPlacement.APP_BENEFITS, customParams: { LineItemsAsFamily: 'any' } })).then(benefits => {
        });
        const geoString = geo ? `&geo=${geo}` : '';
        return httpClient
            .get(`${baseUrl}/_api/marketplace-api/v1/bundle-apps?lang=${local}&number_of_days=30${geoString}`, {
            withCredentials: true,
        })
            .then((res) => {
            return res &&
                res.data &&
                filterDismissedBundleApps(res.data.bundleWebSolutions);
        })
            .catch((error) => {
            console.log('cannot fetch bundle apps', error);
            return Promise.resolve([]);
        });
    }
    return Promise.resolve([]);
};
export const getPermittedActions = (baseUrl, msid, httpClient) => {
    return httpClient
        .get(`${baseUrl}/_serverless/app-market-rpc-proxy/market-actions/${msid}`)
        .then(({ data }) => {
        return data.body;
    })
        .catch((e) => ['']);
};
// The new delete app api, should replace the other delete app function after testing.
export const newDeleteApp = (baseUrl, httpClient, appDefId) => {
    return httpClient
        .post(`${baseUrl}/_api/site-apps/v1/site-apps/bulk-uninstall`, {
        apps: [appDefId],
    })
        .then((data) => data)
        .catch((e) => console.log('cant delete app :('));
};
export const setEmbeddedScriptAppActive = async (newStatus, httpClient, appInstanceId, baseUrl, appStatus) => {
    const properties = {
        ...{ parameters: appStatus.parameters },
        disabled: newStatus,
    };
    return httpClient.post(`${baseUrl}/_api/app-instance-manager/v1/scripts/${appInstanceId}`, { properties }, {
        headers: { cookie: document.cookie },
        withCredentials: true,
    });
};
export const getEmbeddedScriptAppStatus = async (httpClient, appInstanceId, baseUrl) => {
    return httpClient.get(`${baseUrl}/_api/app-instance-manager/v1/scripts/${appInstanceId}`, {
        headers: { cookie: document.cookie },
        withCredentials: true,
    });
};
export const getAllEmbeddedScriptAppsStatus = (httpClient, baseUrl, apps) => {
    const embeddedApps = apps?.filter(isEmbeddedScriptApp) || [];
    const promissArray = embeddedApps?.map(async (app) => {
        const appInstanceId = app?.installationDetails
            ?.instanceId;
        return getEmbeddedScriptAppStatus(httpClient, appInstanceId, baseUrl)
            .then((result) => ({
            ...app,
            parameters: result.data.properties.parameters,
            status: result.data.properties.disabled
                ? embeddedScriptAppStatus.DISABLED
                : embeddedScriptAppStatus.ENABLED,
        }))
            .catch(() => ({ ...app, status: embeddedScriptAppStatus.NO_STATUS }));
    }) || [];
    return Promise.all(promissArray);
};
export const fetchSiteData = (msid, baseUrl, httpClient) => {
    if (msid) {
        return httpClient
            .get(`${baseUrl}/_serverless/app-market-rpc-proxy/premium-features/${msid}`)
            .then((res) => {
            const result = res.data.body || {};
            const premiumFeatures = (result && result.premiumFeatures) || [];
            const domains = (result && result.domains) || [];
            return {
                siteIsPremium: !!premiumFeatures.length,
                siteHasDomain: !!domains.length,
            };
        })
            .catch((error) => {
            return {
                siteIsPremium: true,
                siteHasDomain: true,
            };
        });
    }
    return {
        siteIsPremium: true,
        siteHasDomain: true,
    };
};
export const fetchNewRecommendedApps = async (baseUrl, httpClient, local) => {
    return httpClient
        .get(`${baseUrl}/_api/marketplace-api/v1/web-solutions/recommended?limit=4&lang=${local}`, {
        withCredentials: true,
    })
        .then(({ data }) => data);
};
export const getRecommendationsFromML = (baseUrl, limit, lang, httpClient) => {
    if (httpClient) {
        return httpClient
            .get(`${baseUrl}/_api/marketplace-api/v1/web-solutions/app-market-recommender?limit=${limit}&lang=${lang}`)
            .then(({ data }) => data || {})
            .catch((error) => console.log('cannot fetch ML apps', error));
    }
    return Promise.resolve([]);
};
export const fetchInstalledApps = (baseUrl, httpClient, local, hideBusinessSolutions) => {
    if (httpClient) {
        return httpClient
            .get(`${baseUrl}/_api/managed-apps/v1/managed-apps?lang=${local}`, {
            withCredentials: true,
        })
            .then((res) => {
            const apps = res?.data?.managedApps || [];
            const appsWithBase = apps.filter((app) => app?.appInfo);
            if (hideBusinessSolutions) {
                return filterBusinessSolutionApps(appsWithBase);
            }
            return appsWithBase;
        })
            .catch((error) => console.log('cannot fetch installed apps', error));
    }
    return Promise.resolve([]);
};
export const getFreeTrialAppIds = (httpClientProp) => {
    return httpClientProp
        .request(getEligibleAppsForFreeTrial({}))
        .then(({ data }) => data.eligibleAppIds);
};
//# sourceMappingURL=api.js.map